<template>
  <MRow :gutter="0">
    <MCol class="mx-2">
      <MRow>
        <MCol>
          <div class="text-neutral-light">
            {{ `${$tc('import')} ${$tc('file')} ${$tc('type')}` }}
          </div>
          <FlotoFormItem :validation-label="$t('import_file_type')">
            <MRadioGroup
              v-model="currentImportFileType"
              as-button
              :options="currentImportFileTypeOptions"
              @change="resetFormData"
            />
          </FlotoFormItem>
        </MCol>
      </MRow>
      <MRow>
        <MCol v-if="moduleName === $constants.ASSET" :size="6">
          <div class="text-neutral-light">
            {{ $tc('asset_type') }}
          </div>
          <FlotoFormItem
            id="asset-type"
            :validation-label="`${$tc('asset_type')}`"
          >
            <FlotoAssetTypePicker
              v-model="currentAssetCiType"
              :system-name="getAssetTypeSystemName[subModuleName]"
              :available-asset-type="availableAssetType"
              mandatory
              as-input
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="moduleName === $constants.CMDB" :size="6">
          <div class="text-neutral-light">
            {{ $tc('ci_type') }}
          </div>
          <FlotoFormItem id="ci-type" :validation-label="`${$tc('ci_type')}`">
            <FlotoCITypePicker
              v-model="currentAssetCiType"
              mandatory
              as-input
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="moduleName === $constants.CREDENTIAL" :size="6">
          <div class="text-neutral-light">
            {{ $tc('credential_type') }}
          </div>
          <FlotoFormItem
            id="credential-type"
            :validation-label="`${$tc('credential_type')}`"
          >
            <FlotoDropdownPicker
              v-model="currentCredentialType"
              searchable
              :allow-clear="false"
              as-input
              :options="credentialTypeOptions"
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="moduleName === $constants.SERVICE_CATALOG" :size="6">
          <div class="text-neutral-light field-lable-required">
            {{ $tc('service_catalog') }}
          </div>
          <FlotoFormItem
            id="service-catalog"
            rules="required"
            :validation-label="`${$tc('service_catalog')}`"
          >
            <ServiceCatalogPicker
              v-model="selectedServiceCatalog"
              as-input
              status="published"
              :label="$tc('service_catalog')"
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="moduleName === $constants.IP_NETWORK" :size="6">
          <div class="text-neutral-light">
            {{ $tc('ip_range_type') }}
          </div>
          <FlotoFormItem
            id="ip-range-type"
            :validation-label="`${$tc('ip_range_type')}`"
          >
            <FlotoDropdownPicker
              v-model="currentIpRangeType"
              searchable
              :allow-clear="false"
              as-input
              :options="ipRangeTypeOptions"
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="moduleName === $constants.CLOUD_NETWORK" :size="6">
          <div class="text-neutral-light">
            {{ $tc('cloud_type') }}
          </div>
          <FlotoFormItem
            id="cloud-type"
            :validation-label="`${$tc('cloud_type')}`"
          >
            <FlotoDropdownPicker
              v-model="currentCloudType"
              searchable
              :allow-clear="false"
              as-input
              :options="cloudTypeOptions"
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="moduleName === $constants.PRIVATE_CLOUD_NETWORK" :size="6">
          <div class="text-neutral-light">
            {{ $tc('private_cloud_type') }}
          </div>
          <FlotoFormItem
            id="private-cloud-type"
            :validation-label="`${$tc('private_cloud_type')}`"
          >
            <FlotoDropdownPicker
              v-model="currentPrivateCloudType"
              :disabled="Boolean(currentPrivateCloudType)"
              searchable
              :allow-clear="false"
              as-input
              :options="privateCloudTypeOptions"
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="moduleName === $constants.SNMP_PROPERTY" :size="6">
          <div class="text-neutral-light">
            {{ $tc('snmp_field_type') }}
          </div>
          <FlotoFormItem
            id="snmp-field-type"
            :validation-label="`${$tc('snmp_field_type')}`"
          >
            <FlotoDropdownPicker
              v-model="currentSnmpFieldType"
              searchable
              :allow-clear="false"
              as-input
              :options="snmpFieldTypeOptions"
            />
          </FlotoFormItem>
        </MCol>
        <MCol
          v-if="
            [
              $constants.DEPARTMENT,
              $constants.LOCATION,
              $constants.MANUFACTURER,
              $constants.PRODUCTVENDOR,
              $constants.CATEGORY,
              $constants.DEPENDENT_VALUE,
              $constants.SINGLE_COLUMN,
              $constants.CREDENTIAL,
              $constants.IP_NETWORK,
              $constants.CLOUD_NETWORK,
              $constants.PRIVATE_CLOUD_NETWORK,
              $constants.SNMP_PROPERTY_DEVICE,
              $constants.SNMP_PROPERTY,
            ].indexOf(moduleName) === -1 && importFileType !== 'mpp'
          "
          :size="6"
        >
          <div class="text-neutral-light">
            {{ $t('date') }} {{ $t('format') }}
          </div>
          <FlotoFormItem
            id="date-format"
            :validation-label="`${$t('date')} ${$t('format')}`"
          >
            <FlotoDropdownPicker
              v-model="currentDateFormat"
              searchable
              :allow-clear="false"
              as-input
              :options="dateTypeOptions"
            />
          </FlotoFormItem>
        </MCol>
      </MRow>
      <MDivider
        v-if="
          [
            $constants.DEPARTMENT,
            $constants.LOCATION,
            $constants.MANUFACTURER,
            $constants.PRODUCTVENDOR,
            $constants.CATEGORY,
            $constants.DEPENDENT_VALUE,
            $constants.SINGLE_COLUMN,
            $constants.SNMP_PROPERTY_DEVICE,
          ].indexOf(moduleName) === -1 && importFileType !== 'mpp'
        "
      />
      <h5 class="text-primary">
        {{ $t('upload') }} {{ $t(importFileType) }}
      </h5>
      <div class="text-neutral-light">
        {{
          importFileType === 'mpp'
            ? $t('import_csv.upload_instruction_mpp')
            : $t('import_csv.upload_instruction', {
                type: $tc(importFileType),
              })
        }}
      </div>
      <div
        v-if="sampleFileLink && importFileType !== 'mpp'"
        class="my-2 text-neutral-light"
      >
        <a
          :style="{
            pointerEvents: isLinkDisabled ? 'none' : 'auto',
          }"
          :class="{
            'text-neutral-light': isLinkDisabled,
          }"
          @click="handleDownloadSampleFile"
        >
          {{ $t('import_csv.click_here') }}
        </a>
        {{
          $t('import_csv.sample_file', {
            type: $tc(importFileType),
          })
        }}
      </div>
      <div
        v-if="
          (moduleName === $constants.DEPENDENT_VALUE ||
            moduleName === $constants.SINGLE_COLUMN) &&
          fieldType !== 'ip_address'
        "
        class="text-neutral-light"
      >
        {{
          $t('import_csv.character_validation_csv_import', {
            noOfCharacters: moduleName === $constants.SINGLE_COLUMN ? 255 : 100,
          })
        }}
      </div>
      <div class="flex justify-start">
        <FlotoFormItem
          class="flex-1"
          :validation-label="`${$t(importFileType)}`"
          rules="required"
        >
          <FlotoAttachment
            :key="importFileType"
            v-model="file"
            :max-files="1"
            :allowed-extensions="
              importFileType === 'excel' ? ['xlsx'] : [importFileType]
            "
            ignore-preference-validation
            :button-text="`${$t('select')} ${$t(importFileType)}`"
          />
        </FlotoFormItem>
      </div>
    </MCol>
  </MRow>
</template>

<script>
import Moment from 'moment'
import { getAssetTypeSystemName } from '@modules/asset/helpers/asset-type'
import ServiceCatalogPicker from '@components/data-picker/service-catalog-picker.vue'
import { attachmentDownloadApi } from '@data/attachment'
export default {
  name: 'Step1',
  components: { ServiceCatalogPicker },
  model: { event: 'change', prop: 'selectedFile' },
  props: {
    moduleName: { type: String, required: true },
    subModuleName: { type: String, default: undefined },
    selectedFile: { type: Object, default: undefined },
    dateFormat: { type: String, required: true },
    assetCiType: { type: Number, default: undefined },
    sampleFileLink: { type: String, default: undefined },
    credentialType: { type: String, default: undefined },
    ipRangeType: { type: String, default: undefined },
    cloudType: { type: String, default: undefined },
    privateCloudType: { type: String, default: undefined },
    snmpFieldType: { type: String, default: undefined },
    fieldType: { type: [String], default: undefined },
    serviceCatalogId: { type: Number, default: undefined },
    importFileType: { type: String, required: true },
  },
  data() {
    this.extension = {
      excel: 'xlsx',
      csv: 'csv',
      mpp: 'mpp',
    }
    this.dateTypeOptions = [
      { text: 'dd-MM-yyyy HH:mm', key: 'dd-MM-yyyy HH:mm' },
      { text: 'yyyy-MM-dd HH:mm', key: 'yyyy-MM-dd HH:mm' },
      { text: 'MM-dd-yyyy HH:mm', key: 'MM-dd-yyyy HH:mm' },
      { text: 'dd/MM/yyyy HH:mm', key: 'dd/MM/yyyy HH:mm' },
      { text: 'MM/dd/yyyy HH:mm', key: 'MM/dd/yyyy HH:mm' },
      { text: 'yyyy/MM/dd HH:mm', key: 'yyyy/MM/dd HH:mm' },
    ]
    this.credentialTypeOptions = [
      { text: this.$tc('wmi'), key: 'wmi' },
      { text: this.$tc('ssh'), key: 'ssh' },
      { text: this.$tc('snmp'), key: 'snmp' },
      { text: this.$tc('snmp_v3'), key: 'snmp_v3' },
      { text: this.$tc('vmware'), key: 'vmware' },
      { text: this.$tc('aws'), key: 'aws' },
      { text: this.$tc('azure'), key: 'azure' },
      { text: this.$tc('nutanix'), key: 'nutanix' },
    ]
    this.ipRangeTypeOptions = [
      { text: this.$tc('entire_network'), key: 'entire_network' },
      { text: this.$tc('specific_ip_range'), key: 'specific_range' },
      { text: this.$tc('specific_set_of_ips'), key: 'comma_separated_ips' },
    ]
    this.cloudTypeOptions = [
      { text: this.$tc('aws'), key: 'aws' },
      { text: this.$tc('azure'), key: 'azure' },
    ]
    this.privateCloudTypeOptions = [
      { text: this.$tc('nutanix'), key: 'nutanix' },
    ]
    this.snmpFieldTypeOptions = [
      { text: this.$tc('scalar'), key: 'scalar' },
      { text: this.$tc('tabular'), key: 'tabular' },
    ]
    this.getAssetTypeSystemName = getAssetTypeSystemName
    return {}
  },
  computed: {
    availableAssetType() {
      return [
        getAssetTypeSystemName.hardware,
        getAssetTypeSystemName.software,
        getAssetTypeSystemName.non_it_asset,
      ]
    },
    currentImportFileTypeOptions() {
      return [
        {
          text: this.$t('csv'),
          value: 'csv',
        },
        {
          text: this.$t('excel'),
          value: 'excel',
        },
        ...(this.moduleName === this.$constants.PROJECT
          ? [
              {
                text: this.$t('mpp'),
                value: 'mpp',
              },
            ]
          : []),
      ]
    },
    currentDateFormat: {
      get() {
        return this.dateFormat
      },
      set(v) {
        this.$emit('update:date-format', v)
      },
    },
    currentAssetCiType: {
      get() {
        return this.assetCiType
      },
      set(v) {
        this.$emit('update:asset-ci-type', v)
      },
    },
    currentCredentialType: {
      get() {
        return this.credentialType
      },
      set(v) {
        this.$emit('update:credential-type', v)
      },
    },
    currentIpRangeType: {
      get() {
        return this.ipRangeType
      },
      set(v) {
        this.$emit('update:ip-range-type', v)
      },
    },
    currentCloudType: {
      get() {
        return this.cloudType
      },
      set(v) {
        this.$emit('update:cloud-type', v)
      },
    },
    currentPrivateCloudType: {
      get() {
        return this.privateCloudType
      },
      set(v) {
        this.$emit('update:private-cloud-type', v)
      },
    },
    currentSnmpFieldType: {
      get() {
        return this.snmpFieldType
      },
      set(v) {
        this.$emit('update:snmp-field-type', v)
      },
    },
    file: {
      get() {
        if (this.selectedFile) {
          return [this.selectedFile]
        }
        return []
      },
      set(file) {
        this.$emit('change', file[0])
      },
    },
    selectedServiceCatalog: {
      get() {
        return this.serviceCatalogId
      },
      set(v) {
        this.$emit('update:service-catalog-id', v)
      },
    },
    currentImportFileType: {
      get() {
        return this.importFileType
      },
      set(v) {
        this.$emit('update:import-file-type', v)
      },
    },
    isLinkDisabled() {
      return (
        this.moduleName === this.$constants.SERVICE_CATALOG &&
        !this.selectedServiceCatalog
      )
    },
  },
  methods: {
    resetFormData() {
      this.file = []
    },
    handleDownloadSampleFile() {
      attachmentDownloadApi(
        this.sampleFileLink,
        `${this.$tc(this.moduleName)}_${Moment().format('D-M-YYYY_H-m-s_a')}.${
          this.extension[this.importFileType]
        }`
      )
    },
  },
}
</script>
